/**
 * `?lang=` from the site handoff (§6: `app.lukaaji.com/pricing?plan=…&lang=…`). One of the
 * 12 language codes switches the app language (and is remembered like a manual choice);
 * anything else is ignored.
 */
import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useLanguage, useSetLanguage } from '@/store';
import { isLanguage } from '@/utils/locale';

export function LanguageParamHandler() {
  const [searchParams] = useSearchParams();
  const language = useLanguage();
  const setLanguage = useSetLanguage();
  const requested = searchParams.get('lang');
  // Only a new ?lang= applies; a later manual switch on the same URL is kept.
  const applied = useRef<string | null>(null);

  useEffect(() => {
    if (requested === applied.current) return;
    applied.current = requested;
    if (isLanguage(requested) && requested !== language) {
      setLanguage(requested);
    }
  }, [requested, language, setLanguage]);

  return null;
}
